<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstPerson"
		[loading]="loading == true || Processing == true"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedPerson"
		dataKey="PersonID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--StaffID-->
				<th>
					<p-columnFilter type="text" field="StaffID" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--FirstName-->
				<th>
					<p-columnFilter type="text" field="FirstName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--LastName-->
				<th>
					<p-columnFilter type="text" field="LastName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--Email-->
				<th>
					<!-- <p-columnFilter type="text" field="SchoolFullName" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="StaffID">Staff ID<p-sortIcon field="StaffID"></p-sortIcon></th>
				<th pSortableColumn="FirstName">First Name<p-sortIcon field="FirstName"></p-sortIcon></th>
				<th pSortableColumn="LastName">Last Name<p-sortIcon field="LastName"></p-sortIcon></th>
				<th pSortableColumn="Email">Email<p-sortIcon field="Email"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Person>
			<tr [pSelectableRow]="Person">
				<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Person[col.field] }}
				</td>

				<td>
					<input type="text" class="form-control" [(ngModel)]="Person.Email" />
				</td>
			</tr>
		</ng-template>

		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--StaffID-->
				<th>
					<p-columnFilter type="text" field="StaffID" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--Email-->
				<th>
					<p-columnFilter type="text" field="Email" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--StaffName-->
				<th>
					<p-columnFilter type="text" field="StaffName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--SchoolName-->
				<th>
					<p-columnFilter field="SchoolName" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterSchoolName
								[ngModel]="value"
								[options]="lstSchoolName"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--StaffActiveDesc-->
				<th>
					<p-columnFilter field="StaffActiveDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterStaffActiveDesc
								[ngModel]="value"
								[options]="lstStaffActiveDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--ValidEntryDesc-->
				<th>
					<p-columnFilter field="ValidEntryDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterValidEntryDesc
								[ngModel]="value"
								[options]="lstValidEntryDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--ProgressDesc-->
				<th>
					<p-columnFilter field="ProgressDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterProgressDesc
								[ngModel]="value"
								[options]="lstProgressDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<th class="ButtonWidth"></th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="StaffID">Staff ID<p-sortIcon field="StaffID"></p-sortIcon></th>
				<th pSortableColumn="Email">Email<p-sortIcon field="Email"></p-sortIcon></th>
				<th pSortableColumn="StaffName">Name<p-sortIcon field="StaffName"></p-sortIcon></th>
				<th pSortableColumn="SchoolName">School<p-sortIcon field="SchoolName"></p-sortIcon></th>
				<th pSortableColumn="StaffActiveDesc">Active<p-sortIcon field="StaffActiveDesc"></p-sortIcon></th>
				<th pSortableColumn="ValidEntryDesc">Valid Staff<p-sortIcon field="ValidEntryDesc"></p-sortIcon></th>
				<th pSortableColumn="ProgressDesc">Progress<p-sortIcon field="ProgressDesc"></p-sortIcon></th>

				<th class="ButtonWidth"></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Person>
			<tr [pSelectableRow]="Person" (dblclick)="onRowDblClick(Person)">
				<!--ProgressInt 0 Not Loaded, 1 Loading, 2 Finished Loading-->

				<td
					style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
					[ngClass]="{
						'alert-danger': Person.ValidEntry == 0 && Person.ProgressInt == 2
					}"
				>
					{{ Person["StaffID"] }}
				</td>

				<td
					style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
					[ngClass]="{
						'alert-danger': Person.ValidEntry == 0 && Person.ProgressInt == 2
					}"
				>
					<input *ngIf="!(Person.ValidEntry == 0 && Person.ProgressInt == 2)" type="text" class="form-control" [(ngModel)]="Person.Email" />
					<label style="margin: 0px" *ngIf="Person.ValidEntry == 0 && Person.ProgressInt == 2">{{ Person.Email }}</label>
				</td>

				<td
					style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
					[ngClass]="{
						'alert-danger': Person.ValidEntry == 0 && Person.ProgressInt == 2
					}"
				>
					{{ Person["StaffName"] }}
				</td>

				<td
					style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
					[ngClass]="{
						'alert-danger': Person.ValidEntry == 0 && Person.ProgressInt == 2
					}"
				>
					{{ Person["SchoolName"] }}
				</td>

				<td
					style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
					[style.color]="Person.StaffActive == 1 ? 'Black' : 'Red'"
					[ngClass]="{
						'alert-danger': Person.ValidEntry == 0 && Person.ProgressInt == 2
					}"
				>
					{{ Person["StaffActiveDesc"] }}
				</td>

				<td
					style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
					[ngClass]="{
						'alert-danger': Person.ValidEntry == 0 && Person.ProgressInt == 2
					}"
				>
					{{ Person["ValidEntryDesc"] }}
				</td>

				<td
					style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
					[style.color]="GetColorDesc(Person.ProgressInt)"
					[ngClass]="{
						'alert-danger': Person.ValidEntry == 0 && Person.ProgressInt == 2
					}"
				>
					{{ Person["ProgressDesc"] }}
				</td>

				<td
					class="ButtonWidth"
					[ngClass]="{
						'alert-danger': Person.ValidEntry == 0 && Person.ProgressInt == 2
					}"
				>
					<button class="btn btn-danger" (click)="onRemove(Person)" [disabled]="Person.ProgressInt != 2">
						<i class="fa fa-times" style="margin: 0px" aria-hidden="true"></i>
					</button>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>
